import {
  View,
  Text,
  StyleSheet,
  Keyboard,
  TouchableOpacity,
  Image,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import { useNavigation, StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import CommonTextInput from "../../../common/CommonTextInput";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppColors } from "../../../utility/AppColors";
import { AppImages } from "../../../utility/AppImages";
import { AppScreens } from "../../Utility/AppScreens";
import OTPTextView from "react-native-otp-textinput";
import * as Clipboard from 'expo-clipboard';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import CommonTextInputWeb from "../../../common/CommonTextInputWeb";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../Api/configs";
import { validateEmail } from "../../../utility/Index";
import { ShowLoader } from "../../../common/ShowLoader";
import { confirmResetPassword, resetPassword } from "../../../services/authAPI";
import { CommonButton } from "../../../common/CommonButton";
import { ScreenBGGradientView } from "../../../common/CommonView";

const ResetSetPasswordWebScreen = ({ route }) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const [otpInput, setOtpInput] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const otpRef = useRef<any>(null);

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  // Password validation helpers
  const hasNumber = /[0-9]/.test(newPassword);
  const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword);
  const hasUppercase = /[A-Z]/.test(newPassword);
  const hasLowercase = /[a-z]/.test(newPassword);
  const isAtLeast8Characters = newPassword.length >= 8;
  const passwordsMatch = newPassword && confirmPassword && newPassword === confirmPassword;

  const isPasswordValid =
    hasNumber &&
    hasSpecialCharacter &&
    hasUppercase &&
    hasLowercase &&
    isAtLeast8Characters;

  useEffect(() => {
    const handlePaste = async (event: any) => {
      try {
        let text;
        // Use navigator.clipboard for web, expo-clipboard for mobile
        if (typeof navigator !== "undefined" && navigator.clipboard) {
          text = await navigator.clipboard.readText();
        } else {
          text = await Clipboard.getStringAsync();
        }

        if (text && /^\d{6}$/.test(text)) {
          setOtpInput(text);
          if (otpRef.current) {
            otpRef.current.setValue(text);
          }
        }
      } catch (error) {
        console.log('Paste error:', error);
      }
    };

    // Add paste event listener for web
    if (typeof window !== "undefined") {
      window.addEventListener("paste", handlePaste);
      return () => {
        window.removeEventListener("paste", handlePaste);
      };
    }
  }, []);

  return (
    <View style={styles.container}>
      <ScreenBGGradientView />
      <View
        style={{
          ...(deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG
            ? { flex: 1, justifyContent: "flex-start" }
            : { flex: 0.4, justifyContent: "center" }),
        }}
      >
        {deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG ? (
          <View style={{ alignItems: "center", marginTop: 10 }}>
            <View
              style={{
                borderRadius: 12,
                width: "90%",
                maxWidth: 380,
                height: 260,
                elevation: 20,
              }}
            >
              <Image
                source={AppImages.icMainLogo}
                style={{
                  resizeMode: "contain",
                  width: "100%",
                  height: "100%",
                }}
              />
            </View>
          </View>
        ) : null}
        <View
          style={{
            paddingLeft:
              deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                ? "5%"
                : "15%",
            paddingRight:
              deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ||
                deviceSize === DEVICE_SIZES.MD ||
                deviceSize === DEVICE_SIZES.LG
                ? "5%"
                : 0,
          }}
        >
          {" "}
          <Text
            style={[
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? AppFontStyle.BOLD_ANYBODY_25
                : AppFontStyle.BOLD_ANYBODY_32,
              {
                color: AppColors.white,
                marginVertical: 15,
                ...(deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                  ? { marginTop: 30 }
                  : {}),
              },
            ]}
          >
            Reset Password
          </Text>
          <View>
            {/* OTP View */}
            <View
              style={{
                // backgroundColor: AppColors.red_FF2727,
                flexGrow: 1,
              }}
            >
              <OTPTextView
                ref={otpRef}
                handleTextChange={setOtpInput}
                offTintColor={AppColors.appBlueColor_3A5175}
                tintColor={AppColors.themeColor_0A89AD}
                containerStyle={styles.textInputContainer}
                textInputStyle={styles.roundedTextInput}
                inputCount={6}
                inputCellLength={1}
                keyboardType="numeric"
              />
            </View>

            {/* Didn't get the code? Resnd code */}
            <View
              style={{
                flexDirection: "row",
                marginVertical: 20,
              }}
            >
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  {
                    color: "white",
                  },
                ]}
              >
                Didn't get the code?{" "}
              </Text>
              <TouchableOpacity
                onPress={async () => {
                  const param = routeData.authType === 'phone'
                    ? {
                      phoneNumber: routeData.phoneNumber,
                      authType: 'phone',
                    }
                    : {
                      username: routeData.username,
                      authType: 'email',
                    };

                  try {
                    setShowLoader(true);

                    const data = await resetPassword(param);

                    // Check if the status code is 200 or 201
                    if (data.statusCode === 200 || data.statusCode === 201) {
                      toast.success(data.body.message);

                      // navigateToScreen(navigation, AppScreens.ResetSetPasswordWebScreen, { username: username });
                    } else {
                      // Handle other status codes or errors
                      toast.error(data.body.error || "Reset Password Failed");
                      navigateToScreen(navigation, AppScreens.LoginWebScreen);
                    }
                  } catch (error) {
                    toast.error(error.message);
                  } finally {
                    setShowLoader(false);
                  }
                }}
              >
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, { color: "white" }]}
                >
                  Resend code
                </Text>
              </TouchableOpacity>
            </View>

            {/* New Password */}
            <CommonTextInputWeb
              placeholder="New Password"
              mainStyle={[styles.inputStyle]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
              prefixIconVisibility={false}
              onChangeText={setNewPassword}
              isPassword={true}
              value={newPassword}
              secureTextEntry={showNewPassword ? false : true}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              maxLength={50}
              onPressEyeIcon={() => {
                setShowNewPassword(!showNewPassword);
              }}
              rightIcon={showNewPassword ? AppImages.icEye : AppImages.icEyeClose}
              showEyeIcon={true}
              rightIconStyle={{ width: 20, height: 20 }}
            />

            {/* Confirm new password */}
            <CommonTextInputWeb
              placeholder="Confirm new password"
              mainStyle={[styles.inputStyle]}
              inputStyle={[AppFontStyle.REGULAR_ANYBODY_12]}
              prefixIconVisibility={false}
              onChangeText={setConfirmPassword}
              isPassword={true}
              value={confirmPassword}
              secureTextEntry={showConfirmPassword ? false : true}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              maxLength={50}
              onPressEyeIcon={() => {
                setShowConfirmPassword(!showConfirmPassword);
              }}
              rightIcon={showConfirmPassword ? AppImages.icEye : AppImages.icEyeClose}
              showEyeIcon={true}
              rightIconStyle={{ width: 20, height: 20 }}
            />

            {/* Password Guidelines */}
            <View style={{ marginVertical: 15 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: hasNumber ? AppColors.appGreenColor_51AF07 : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {hasNumber ? "✔" : "✘"} Contains at least 1 number
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: hasSpecialCharacter ? AppColors.appGreenColor_51AF07 : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {hasSpecialCharacter ? "✔" : "✘"} Contains at least 1 special character
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: hasUppercase ? AppColors.appGreenColor_51AF07 : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {hasUppercase ? "✔" : "✘"} Contains at least 1 uppercase letter
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: hasLowercase ? AppColors.appGreenColor_51AF07 : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {hasLowercase ? "✔" : "✘"} Contains at least 1 lowercase letter
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: isAtLeast8Characters
                      ? AppColors.appGreenColor_51AF07
                      : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {isAtLeast8Characters ? "✔" : "✘"} Minimum length of 8 characters
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: passwordsMatch
                      ? AppColors.appGreenColor_51AF07
                      : AppColors.white,
                    lineHeight: 20,
                  },
                ]}
              >
                {passwordsMatch ? "✔" : "✘"} Passwords match
              </Text>
            </View>

            {/* Reset Button */}
            <View
              style={{
                alignItems: "center",
              }}
            >
              {/* Reset Button */}
              <TouchableOpacity
                style={{
                  width: "58%",
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: AppColors.buttonRed_DC2626,
                  borderRadius: 20,
                  marginVertical: 10,
                }}
                onPress={async () => {
                  if (!isPasswordValid) {
                    toast.error("Password does not meet the required conditions.");
                    return;
                  }

                  if (!passwordsMatch) {
                    toast.error("Passwords do not match.");
                    return;
                  }

                  if (checkValidation()) {
                    const param = {
                      username: routeData.username,
                      phoneNumber: routeData.phoneNumber,
                      authType: routeData.authType || 'email',
                      newPassword: confirmPassword,
                      confirmationCode: otpInput,
                    };

                    try {
                      setShowLoader(true);

                      const data = await confirmResetPassword(param);

                      if (data.statusCode === 200 || data.statusCode === 201) {
                        toast.success(data.body.message);
                        navigateToScreen(navigation, AppScreens.LoginWebScreen);
                      } else if (data.statusCode === 500) {
                        toast.error(data.body.error);
                        setOtpInput("");
                      } else {
                        toast.error(data.body.error || "Reset Password Failed");
                      }
                    } catch (error) {
                      toast.error(error.message);
                    } finally {
                      setShowLoader(false);
                    }
                  }
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_14,
                    { color: AppColors.white },
                  ]}
                >
                  Reset Password
                </Text>
              </TouchableOpacity>

              {/* Go back to previous page */}
              <TouchableOpacity
                style={{
                  height: 40,
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 20,
                }}
                onPress={() => {
                  navigateToScreen(navigation, AppScreens.ResetPasswordWebScreen);
                }}
              >
                <Text
                  style={[
                    AppFontStyle.MEDIUM_ANYBODY_12,
                    { color: AppColors.white },
                  ]}
                >
                  Go back
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>

      {deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.MD ||
        deviceSize === DEVICE_SIZES.LG ? null : (
        <View
          style={[
            {
              position: "relative",
              justifyContent: "center",
              alignItems: "center",
              paddingRight: "5%",
              flex: 0.6,
            },
          ]}
        >
          <View
            style={{
              borderRadius: 12,
              elevation: 20,
            }}
          >
            <Image
              source={AppImages.icMainLogo}
              style={{
                width: 764,
                height: 468,
              }}
              resizeMode="contain"
            />
          </View>
          <View
            style={{
              flexDirection: "row",
              position: "absolute",
              bottom: 20, // Adjust this for vertical alignment
              right: 30, // Adjust this for horizontal alignment
              alignItems: "center",
            }}
          >
            {/* YouTube logo */}
            <Image
              source={AppImages.icYoutubeLogo}
              style={{
                width: 56, // Set specific width and height instead of percentage
                height: 56,
              }}
              resizeMode="contain"
            />

            {/* Twitch logo */}
            <Image
              source={AppImages.icTwitchLogo}
              style={{
                width: 56,
                height: 56,
              }}
              resizeMode="contain"
            />
          </View>
        </View>
      )}
      <View
        style={{
          flexDirection: "row",
          position: "absolute",
          bottom: 20,
          right: 30,
          alignItems: "center",
        }}
      >
        <Image
          source={AppImages.icYoutubeLogo}
          style={{
            width: 56,
            height: 56,
          }}
          resizeMode="contain"
        />
        <Image
          source={AppImages.icTwitchLogo}
          style={{
            width: 56,
            height: 56,
          }}
          resizeMode="contain"
        />
      </View>
      {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
    </View>
  );

  function checkValidation() {
    if (otpInput.length != 6) {
      toast.error("Please Enter valid OTP");
      return false;
    } else if (newPassword == "") {
      toast.error("Please Enter New Password");
      return false;
    } else if (confirmPassword == "") {
      toast.error("Please Enter Confirm Password");
      return false;
    } else if (newPassword != confirmPassword) {
      toast.error("New Password and Confirm Password are not match");
      return false;
    }
    return true;
  }
};

export default ResetSetPasswordWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 30,
    },
    inputStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginBottom: 10,
    },
    textInputContainer: {
      height: 60,
    },
    roundedTextInput: {
      borderRadius: 14,
      borderWidth: 1,
      borderBottomWidth: 1,
      alignContent: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      fontSize: 16,
      color: AppColors.white,
      elevation: 2,
      width: 60,
      height: 60,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      textInputContainer: {
        height: 60,
        justifyContent: "center",
        alignContent: "space-between",
      },
      roundedTextInput: {
        alignContent: "space-between",
      },
    },
    [DEVICE_SIZES.MD]: {
      textInputContainer: {
        height: 60,
        justifyContent: "center",
        alignContent: "space-between",
      },
      roundedTextInput: {
        alignContent: "space-between",
      },
    },
    [DEVICE_SIZES.SM]: {
      textInputContainer: {
        height: 45,
        justifyContent: "center",
        alignContent: "space-between",
      },
      roundedTextInput: {
        width: 45,
        height: 45,
        alignContent: "space-between",
      },
    },
    [DEVICE_SIZES.XS]: {
      textInputContainer: {
        height: 55,
        justifyContent: "center",
        alignContent: "space-between",
      },
      roundedTextInput: {
        width: 50,
        height: 55,
        alignContent: "space-between",
      },
    },
  }
);
